import { SimpleStoreInterface } from 'reseller/interfaces';
import { runInAction, makeAutoObservable } from 'mobx';
import { getErrorMessage } from 'shared/api';
import { BinTagInterface } from '../dictionaries.module';

class BinTagsStore implements SimpleStoreInterface<BinTagInterface> {
  fetchMethod: () => any;

  isFetching = false;

  isReceived = false;

  fetchingError?: string;

  list = [] as BinTagInterface[];

  constructor(fetchMethod: () => any) {
    makeAutoObservable(this);
    this.fetchMethod = fetchMethod;
  }

  async getList(): Promise<BinTagInterface[]> {
    if (!this.isFetching && !this.isReceived) {
      await this.fetch();
    }

    return this.list || [];
  }

  // eslint-disable-next-line consistent-return
  async fetch(): Promise<BinTagInterface[] | void> {
    runInAction(() => {
      this.fetchingError = undefined;
      this.isFetching = true;
      this.isReceived = false;
    });

    try {
      const { data } = await this.fetchMethod();

      const tempArr = [] as BinTagInterface[];
      Object.keys(data).forEach((key: string): void => {
        tempArr.push(data[key]);
      });

      runInAction(() => {
        this.isFetching = false;
        this.isReceived = true;
        this.list = tempArr;
      });

      return this.list;
    } catch (err: any) {
      runInAction(() => {
        this.fetchingError = getErrorMessage(err);
        this.isReceived = false;
        this.isFetching = false;
      });
    }
  }
}

export default BinTagsStore;
